import { JobState } from '@treadinc/horizon-api-spec';
import { t } from 'i18next';
import { noop } from 'lodash-es';
import { useCallback, useMemo } from 'react';

import { InfiniteQuery, InfiniteQueryOption } from './constants';

const buildOptions = (excludedStates: JobState[] = []): InfiniteQueryOption[] =>
  Object.values(JobState)
    .filter((state) => !excludedStates.includes(state))
    .map((state) => ({
      label: t(`status.${state}`),
      value: `${state}`,
    }));

const data = buildOptions();

export default function useJobStatusInfiniteQuery(
  excludedStates?: JobState[],
): InfiniteQuery {
  const noopFn = useCallback(() => {
    return noop;
  }, []);

  const selectableData = useMemo(
    () => (excludedStates?.length ? buildOptions(excludedStates) : data),
    [excludedStates],
  );

  return {
    clear: noopFn,
    data: selectableData,
    fetch: noopFn,
    fetchMore: undefined,
    isDummyQuery: true,
  };
}
